const films = [
  {
    title: 'We Are 18',
    id: 1,
    year: 1959,
    cast: ['Isana Medel'],
    genres: ['Comedy'],
    producers: ['Cibeles Films'],
    composers: [],
    pseudonyms: [],
    locations: [],
    imdb: 'tt0053342'
  },
  {
    title: 'Red Lips',
    id: 2,
    year: 1960,
    cast: ['Isana Medel'],
    genres: ['Comedy', 'Crime', 'Thriller'],
    producers: ['Cibeles Films'],
    composers: [],
    pseudonyms: [],
    locations: [],
    imdb: 'tt0054012'
  },
  {
    title: 'The Queen of the Tabarin',
    id: 3,
    year: 1960,
    cast: ['Mikaela', 'Juan Antonio Riquelme'],
    genres: ['Comedy', 'Drama'],
    producers: ['Eurociné', 'CIFESA', 'Hispamer'],
    composers: [],
    pseudonyms: [],
    locations: [],
    imdb: 'tt0054238'
  },
  {
    title: 'Gold Diggers of 1930',
    id: 4,
    year: 1960,
    cast: ['Mikaela', 'Juan Antonio Riquelme'],
    genres: ['Comedy', 'Musical'],
    producers: ['Eurociné', 'CIFESA', 'Hispamer'],
    composers: [],
    pseudonyms: [],
    locations: [],
    imdb: 'tt0056647'
  },
  {
    title: 'The Awful Dr. Orlof',
    id: 5,
    year: 1961,
    cast: ['Howard Vernon', 'Juan Antonio Riquelme', 'Diana Lorys'],
    genres: ['Horror', 'Mad Scientists'],
    producers: ['Eurociné', 'Hispamer'],
    composers: [],
    pseudonyms: ['David Khune'],
    locations: [],
    imdb: 'tt0056040'
  },
  {
    title: 'Death Whistles a Blues',
    id: 6,
    year: 1962,
    cast: ['Georges Rollin'],
    genres: ['Crime', 'Drama'],
    producers: ['Eurociné'],
    composers: ['Jess Franco'],
    pseudonyms: [],
    locations: [],
    imdb: 'tt0056259'
  },
  {
    title: 'The Sadistic Baron Von Klaus',
    id: 7,
    year: 1962,
    cast: ['Howard Vernon', 'Georges Rollin'],
    genres: ['Horror'],
    producers: [],
    composers: ['Jess Franco', 'Daniel White'],
    pseudonyms: ['David Khune'],
    locations: [],
    imdb: 'tt0056220'
  },
  {
    title: 'Rififi in the City (Do You Remember Paco?)',
    id: 8,
    year: 1963,
    cast: [],
    genres: ['Crime', 'Thriller', 'Drama'],
    producers: [],
    composers: [],
    pseudonyms: ['David Khune'],
    locations: [],
    imdb: 'tt0056925'
  },
  {
    title: 'The Plainsman',
    id: 9,
    year: 1963,
    cast: ['Georges Rollin'],
    genres: ['Western'],
    producers: ['Eurociné'],
    composers: ['Daniel White'],
    pseudonyms: ['David Khune'],
    locations: [],
    imdb: 'tt0057257'
  },
  {
    title: "Dr. Orloff's Monster",
    id: 10,
    year: 1964,
    cast: [],
    genres: ['Horror', 'Mad Scientists'],
    producers: ['Eurociné'],
    composers: ['Daniel White'],
    pseudonyms: ['David Khune'],
    locations: [],
    imdb: 'tt0058563'
  },
  {
    title: 'The Diabolical Dr. Z',
    id: 11,
    year: 1965,
    cast: ['Howard Vernon'],
    genres: ['Horror', 'Mad Scientists'],
    producers: ['Hesperia Films', 'Speva Films', 'Ciné Alliance'],
    composers: ['Daniel White'],
    pseudonyms: ['David Khune'],
    locations: [],
    trivia: ['Jean-Claude Carrière (screenplay)'],
    imdb: 'tt0060701'
  },
  {
    title: 'Attack of the Robots',
    id: 12,
    year: 1965,
    cast: ['Eddie Constantine', 'Fernando Rey'],
    genres: ['Comedy', 'Science Fiction'],
    producers: ['Hesperia Films', 'Speva Films', 'Ciné Alliance'],
    composers: [],
    pseudonyms: [],
    locations: [],
    trivia: ['Jean-Claude Carrière (screenplay)'],
    imdb: 'tt0060215'
  },
  {
    title: 'Golden Horn',
    id: 13,
    year: 1966,
    cast: ['Eddie Constantine', 'Diana Lorys'],
    genres: ['Action', 'Adventure', 'Thriller', 'Eurospy'],
    producers: ['Hesperia Films'],
    composers: [],
    pseudonyms: [],
    locations: [],
    imdb: 'tt0060467'
  },
  {
    title: 'Lucky the Inscrutable',
    id: 14,
    year: 1966,
    cast: ['Rosalba Neri', 'Diana Lorys'],
    genres: ['Action', 'Adventure', 'Thriller', 'Eurospy'],
    producers: [],
    composers: ['Bruno Nicolai'],
    pseudonyms: [],
    locations: [],
    imdb: 'tt0061339'
  },
  {
    title: 'Succubus',
    id: 15,
    year: 1967,
    cast: ['Janine Reynaud', 'Howard Vernon', 'Jack Taylor', 'Michel Lemoine'],
    genres: ['Horror'],
    producers: ['Aquila Films'],
    composers: ['Bruno Nicolai'],
    pseudonyms: [],
    locations: [],
    trivia: ['Karl Lagerfeld (costume design)'],
    imdb: 'tt0062032'
  },
  {
    title: 'Sadisterotica',
    id: 16,
    year: 1967,
    cast: ['Janine Reynaud', 'Michel Lemoine'],
    genres: ['Comedy', 'Mystery', 'Thriller', 'Eurospy'],
    producers: ['Aquila Films'],
    composers: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0061453'
  },
  {
    title: 'Kiss Me Monster',
    id: 17,
    year: 1967,
    cast: ['Janine Reynaud', 'Michel Lemoine'],
    genres: ['Adventure', 'Mystery', 'Eurospy'],
    producers: ['Aquila Films'],
    composers: ['Daniel White'],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0061432'
  },
  {
    title: 'The Blood of Fu Manchu',
    id: 18,
    year: 1967,
    cast: ['Christopher Lee', 'Maria Röhm'],
    genres: ['Adventure', 'Crime', 'Pulp'],
    producers: ['Towers of London (Harry Alan Towers)'],
    composers: ['Daniel White'],
    screenplay: ['Harry Alan Towers'],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0062741'
  },
  {
    title: 'The Girl From Rio',
    id: 19,
    year: 1968,
    cast: ['Maria Röhm', 'George Sanders'],
    genres: ['Action', 'Adventure'],
    producers: ['Towers of London (Harry Alan Towers)'],
    composers: ['Daniel White'],
    screenplay: ['Harry Alan Towers'],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0062808'
  },
  {
    title: '99 Women',
    id: 20,
    year: 1968,
    cast: [
      'Maria Schell',
      'Maria Röhm',
      'Mercedes McCambridge',
      'Rosalba Neri',
      'Herbert Lom',
      'Juan Antonio Riquelme'
    ],
    genres: ['Action', 'Adventure', 'Women In Prison'],
    producers: ['Towers of London (Harry Alan Towers)'],
    composers: ['Bruno Nicolai'],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: ['Bruno Mattei (editor)'],
    imdb: 'tt0063977'
  },
  {
    title: 'Justine',
    id: 21,
    year: 1968,
    cast: [
      'Klaus Kinski',
      'Maria Röhm',
      'Mercedes McCambridge',
      'Howard Vernon',
      'Jack Palance',
      'Rosalba Neri'
    ],
    genres: ['Erotica', 'Horror', 'Sadism'],
    producers: ['Towers of London (Harry Alan Towers)'],
    composers: ['Bruno Nicolai'],
    screenplay: ['Harry Alan Towers'],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0062870'
  },
  {
    title: 'The Castle of Fu Manchu',
    id: 22,
    year: 1968,
    cast: ['Christopher Lee', 'Rosalba Neri'],
    genres: ['Adventure', 'Crime', 'Pulp'],
    producers: ['Towers of London (Harry Alan Towers)'],
    composers: [],
    screenplay: ['Harry Alan Towers'],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0064338'
  },
  {
    title: 'Venus in Furs',
    id: 23,
    year: 1968,
    cast: ['Klaus Kinski', 'Maria Röhm', 'Paul Müller'],
    genres: ['Horror', 'Erotica', 'Psychedelia'],
    producers: [],
    composers: [],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0064789'
  },
  {
    title: 'Eugénie... The Story of her Journey into Perversion',
    id: 24,
    year: 1969,
    cast: ['Maria Röhm', 'Jack Taylor', 'Christopher Lee', 'Paul Müller'],
    genres: ['Erotica', 'Psychedelia', 'Sadism'],
    producers: ['Towers of London (Harry Alan Towers)'],
    composers: ['Bruno Nicolai'],
    screenplay: ['Harry Alan Towers'],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0064494'
  },
  {
    title: 'Sex Charade',
    id: 25,
    year: 1969,
    cast: [
      'Maria Röhm',
      'Jack Taylor',
      'Soledad Miranda',
      'Diana Lorys',
      'Howard Vernon',
      'Paul Müller'
    ],
    genres: ['Horror'],
    producers: [],
    composers: ['Bruno Nicolai'],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: ['Lost Film'],
    imdb: 'tt1921086'
  },
  {
    title: 'The Bloody Judge',
    id: 26,
    year: 1969,
    cast: [
      'Maria Schell',
      'Maria Röhm',
      'Christopher Lee',
      'Howard Vernon',
      'Diana Lorys'
    ],
    genres: ['Horror', 'Period'],
    producers: ['Towers of London (Harry Alan Towers)', 'Fénix Films'],
    composers: ['Bruno Nicolai'],
    screenplay: ['Harry Alan Towers'],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0064727'
  },
  {
    title: 'Nightmares Come at Night',
    id: 27,
    year: 1969,
    cast: ['Soledad Miranda', 'Jack Taylor', 'Paul Müller', 'Diana Lorys'],
    genres: ['Erotica', 'Drama', 'Horror', 'Crime'],
    producers: [],
    composers: ['Bruno Nicolai'],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0066357'
  },
  {
    title: 'Count Dracula',
    id: 28,
    year: 1969,
    cast: [
      'Soledad Miranda',
      'Jack Taylor',
      'Paul Müller',
      'Christopher Lee',
      'Herbert Lom',
      'Maria Röhm'
    ],
    genres: ['Erotica', 'Drama', 'Horror', 'Crime'],
    producers: ['Towers of London (Harry Alan Towers)', 'Fénix Films'],
    composers: ['Bruno Nicolai'],
    screenplay: ['Harry Alan Towers'],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0065569'
  },
  {
    title: 'Eugenie',
    id: 29,
    year: 1970,
    cast: ['Soledad Miranda', 'Paul Müller', 'Alice Arno'],
    genres: ['Erotica', 'Drama', 'Thriller', 'Sadism'],
    producers: ['Eurociné'],
    composers: ['Bruno Nicolai'],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0218181'
  },
  {
    title: 'Vampyros Lesbos',
    id: 30,
    year: 1970,
    cast: ['Soledad Miranda', 'Paul Müller', 'Ewa Strömberg'],
    genres: ['Erotica', 'Horror', 'Vampires', 'Psychedelia'],
    producers: ['Fénix Films'],
    composers: ['Jess Franco', 'Manfred Hübler'],
    screenplay: [],
    pseudonyms: ['David Khune'],
    locations: [],
    trivia: [],
    imdb: 'tt0066380'
  },
  {
    title: 'She Killed in Ecstasy',
    id: 31,
    year: 1970,
    cast: [
      'Soledad Miranda',
      'Paul Müller',
      'Ewa Strömberg',
      'Howard Vernon',
      'Horst Tappert'
    ],
    genres: ['Erotica', 'Thriller'],
    producers: ['Fénix Films'],
    composers: ['Bruno Nicolai', 'Manfred Hübler'],
    screenplay: [],
    pseudonyms: ['David Khune'],
    locations: [],
    trivia: [],
    imdb: 'tt0066104'
  },
  {
    title: 'Juliette',
    id: 32,
    year: 1970,
    cast: ['Soledad Miranda', 'Paul Müller'],
    genres: ['Erotica', 'Crime', 'Sadism'],
    producers: [],
    composers: [],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: ['Unfinished/Unreleased'],
    imdb: 'tt0368819'
  },
  {
    title: 'The Devil Came From Akasava',
    id: 33,
    year: 1970,
    cast: [
      'Soledad Miranda',
      'Paul Müller',
      'Howard Vernon',
      'Ewa Strömberg',
      'Horst Tappert'
    ],
    genres: ['Adventure', 'Thriller', 'Eurospy', 'Krimi'],
    producers: ['Fénix Films'],
    composers: ['Manfred Hübler'],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0067846'
  },
  {
    title: 'X312 - Flight to Hell',
    id: 34,
    year: 1970,
    cast: ['Paul Müller', 'Howard Vernon', 'Ewa Strömberg'],
    genres: ['Action', 'Crime', 'Drama'],
    producers: ['Fénix Films'],
    composers: ['Bruno Nicolai'],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0067999'
  },
  {
    title: 'The Deadly Avenger of Soho',
    id: 35,
    year: 1971,
    cast: ['Horst Tappert'],
    genres: ['Horror', 'Crime', 'Mystery', 'Krimi'],
    producers: ['Fénix Films'],
    composers: ['Jess Franco'],
    screenplay: [],
    pseudonyms: ['David Khune'],
    locations: [],
    trivia: [],
    imdb: 'tt0067453'
  },
  {
    title: 'The Vengeance of Dr. Mabuse',
    id: 36,
    year: 1971,
    cast: ['Jack Taylor', 'Ewa Strömberg'],
    genres: ['Horror', 'Crime', 'Mad Scientists'],
    producers: ['Fénix Films'],
    composers: ['Jess Franco'],
    screenplay: [],
    pseudonyms: ['David Khune'],
    locations: [],
    trivia: [],
    imdb: 'tt0071439'
  },
  {
    title: 'Virgins Report',
    id: 37,
    year: 1971,
    cast: ['Howard Vernon', 'Britt Nichols'],
    genres: ['Comedy', 'Drama', 'Sex Education', 'Erotica', 'Docudrama'],
    producers: [],
    composers: ['Daniel White'],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0067282'
  },
  {
    title: 'Sexy Darlings',
    id: 38,
    year: 1971,
    cast: ['Howard Vernon', 'Paul Müller', 'Anne Libert'],
    genres: ['Comedy', 'Adventure'],
    producers: ['Comptoir français du film (Robert de Nesle)'],
    composers: ['Daniel White', 'Bruno Nicolai'],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0067682'
  },
  {
    title: 'A Virgin Among the Living Dead',
    id: 39,
    year: 1971,
    cast: [
      'Howard Vernon',
      'Paul Müller',
      'Anne Libert',
      'Alice Arno',
      'Britt Nichols'
    ],
    genres: ['Horror'],
    producers: ['Comptoir français du film (Robert de Nesle)', 'Eurociné'],
    composers: ['Bruno Nicolai'],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0066914'
  },
  {
    title: 'Dracula Prisoner of Frankenstein',
    id: 40,
    year: 1971,
    cast: ['Howard Vernon', 'Anne Libert', 'Britt Nichols', 'Luis Barboo'],
    genres: ['Horror', 'Vampires'],
    producers: ['Comptoir français du film (Robert de Nesle)', 'Fénix Films'],
    composers: ['Bruno Nicolai', 'Daniel White'],
    screenplay: [],
    pseudonyms: ['David Khune'],
    locations: [],
    trivia: [],
    imdb: 'tt0065660'
  },
  {
    title: "Dracula's Daughter",
    id: 41,
    year: 1972,
    cast: ['Howard Vernon', 'Anne Libert', 'Britt Nichols'],
    genres: ['Horror', 'Vampires'],
    producers: ['Comptoir français du film (Robert de Nesle)', 'Fénix Films'],
    composers: [],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0068583'
  },
  {
    title: "Devil's Island Lovers",
    id: 42,
    year: 1972,
    cast: ['Howard Vernon', 'Anne Libert', 'Luis Barboo'],
    genres: ['Women In Prison'],
    producers: ['Comptoir français du film (Robert de Nesle)', 'Fénix Films'],
    composers: ['Bruno Nicolai'],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0069142'
  },
  {
    title: 'The Erotic Rites of Frankenstein',
    id: 43,
    year: 1972,
    cast: [
      'Howard Vernon',
      'Anne Libert',
      'Britt Nichols',
      'Lina Romay',
      'Luis Barboo'
    ],
    genres: ['Horror', 'Mad Scientists'],
    producers: ['Comptoir français du film (Robert de Nesle)', 'Fénix Films'],
    composers: ['Daniel White'],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0068559'
  },
  {
    title: 'The Demons',
    id: 44,
    year: 1972,
    cast: ['Howard Vernon', 'Anne Libert', 'Britt Nichols', 'Luis Barboo'],
    genres: ['Horror', 'Period'],
    producers: ['Comptoir français du film (Robert de Nesle)', 'Fénix Films'],
    composers: ['Daniel White', 'Jess Franco', 'Jean Bernard Raiteux'],
    screenplay: [],
    pseudonyms: ['Clifford Brown', 'David Khune'],
    locations: [],
    trivia: [],
    imdb: 'tt0068522'
  },
  {
    title: 'A Fifteen Year Old Captain',
    id: 45,
    year: 1972,
    cast: ['Howard Vernon', 'William Berger', 'Luis Barboo'],
    genres: ['Adventure'],
    producers: ['Comptoir français du film (Robert de Nesle)', 'Fénix Films'],
    composers: ['Bruno Nicolai', 'Jess Franco'],
    screenplay: [],
    pseudonyms: ['Clifford Brown'],
    locations: [],
    trivia: [],
    imdb: 'tt0069437'
  },
  {
    title: 'The Silence of the Tomb',
    id: 46,
    year: 1972,
    cast: ['Montserrat Prous'],
    genres: ['Horror'],
    producers: [],
    composers: ['Jess Franco'],
    screenplay: [],
    pseudonyms: ['David Khune'],
    locations: [],
    trivia: [],
    imdb: 'tt0072162'
  },
  {
    title: 'Les Ébranlées',
    id: 47,
    year: 1972,
    cast: ['Montserrat Prous', 'Anne Libert', 'Howard Vernon', 'Luis Barboo'],
    genres: ['Crime', 'Drama'],
    producers: ['Comptoir français du film (Robert de Nesle)'],
    composers: [],
    screenplay: [],
    pseudonyms: ['Clifford Brown'],
    locations: [],
    trivia: [],
    imdb: 'tt0068526'
  },
  {
    title: 'Sinner: The Secret Diary of a Nymphomaniac',
    id: 48,
    year: 1972,
    cast: ['Montserrat Prous', 'Anne Libert', 'Howard Vernon'],
    genres: ['Erotica', 'Drama'],
    producers: ['Comptoir français du film (Robert de Nesle)'],
    composers: ['Jean Bernard Raiteux', 'Vladimir Cosma'],
    screenplay: [],
    pseudonyms: ['Clifford Brown'],
    locations: [],
    trivia: [],
    imdb: 'tt0069973'
  },
  {
    title: 'Relax Baby',
    id: 49,
    year: 1972,
    cast: ['Montserrat Prous', 'Lina Romay'],
    genres: [],
    producers: [],
    composers: [],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: ['Unfinished/Unreleased'],
    imdb: 'tt0254733'
  },
  {
    title: 'The Sinister Eyes of Dr. Orloff',
    id: 50,
    year: 1972,
    cast: ['Montserrat Prous', 'Lina Romay', 'William Berger'],
    genres: ['Horror', 'Mad Scientists'],
    producers: [],
    composers: ['Jess Franco'],
    screenplay: [],
    pseudonyms: ['David Khune'],
    locations: [],
    trivia: [],
    imdb: 'tt0070471'
  },
  {
    title: 'How to Seduce a Virgin',
    id: 51,
    year: 1973,
    cast: ['Alice Arno', 'Lina Romay', 'Howard Vernon'],
    genres: ['Horror', 'Erotica', 'Sadism'],
    producers: ['Comptoir français du film (Robert de Nesle)'],
    composers: [],
    screenplay: [],
    pseudonyms: ['Clifford Brown'],
    locations: [],
    trivia: [],
    imdb: 'tt0070543'
  },
  {
    title: 'Countess Perverse',
    id: 52,
    year: 1973,
    cast: ['Alice Arno', 'Lina Romay', 'Howard Vernon'],
    genres: ['Horror', 'Erotica', 'Action', 'Adventure'],
    producers: ['Comptoir français du film (Robert de Nesle)'],
    composers: ['Jean Bernard Raiteux'],
    screenplay: [],
    pseudonyms: ['Clifford Brown'],
    locations: [],
    trivia: [],
    imdb: 'tt0069930'
  },
  {
    title: 'The Mystery of the Red Castle',
    id: 53,
    year: 1973,
    cast: ['Lina Romay', 'Montserrat Prous', 'Luis Barboo'],
    genres: [],
    producers: [],
    composers: [],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: ['Unfinished/Unreleased'],
    imdb: 'tt0070398'
  },
  {
    title: 'The Lustful Amazon',
    id: 54,
    year: 1973,
    cast: ['Alice Arno', 'Lina Romay', 'Montserrat Prous'],
    genres: ['Adventure'],
    producers: ['Comptoir français du film (Robert de Nesle)'],
    composers: [],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0070118'
  },
  {
    title: 'Les Gloutonnes',
    id: 55,
    year: 1973,
    cast: [
      'Alice Arno',
      'Lina Romay',
      'Montserrat Prous',
      'Howard Vernon',
      'Pamela Stanford'
    ],
    genres: ['Adventure', 'Fantasy', 'Erotica'],
    producers: ['Comptoir français du film (Robert de Nesle)'],
    composers: [],
    screenplay: [],
    pseudonyms: ['Clifford Brown'],
    locations: [],
    trivia: [],
    imdb: 'tt0297149'
  },
  {
    title: 'Al otro lado del espejo/Le Miroir obscène',
    id: 56,
    year: 1973,
    cast: ['Alice Arno', 'Lina Romay', 'Howard Vernon', 'Pamela Stanford'],
    genres: ['Horror', 'Drama', 'Erotica'],
    producers: ['Comptoir français du film (Robert de Nesle)'],
    composers: [],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0070396'
  },
  {
    title: 'Female Vampire',
    id: 57,
    year: 1973,
    cast: ['Alice Arno', 'Lina Romay', 'Jack Taylor', 'Luis Barboo'],
    genres: ['Horror', 'Vampires', 'Erotica'],
    producers: ['Eurociné'],
    composers: ['Daniel White'],
    screenplay: [],
    pseudonyms: ['J.P. Johnson'],
    locations: [],
    trivia: [],
    imdb: 'tt0069745'
  },
  {
    title: 'Night of the Skull',
    id: 58,
    year: 1973,
    cast: ['William Berger', 'Lina Romay', 'Antonio Mayans', 'Luis Barboo'],
    genres: ['Horror', 'Vampires', 'Erotica'],
    producers: ['Fénix Films'],
    composers: [],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0074971'
  },
  {
    title: 'The Hot Nights of Linda',
    id: 59,
    year: 1973,
    cast: ['Alice Arno', 'Lina Romay', 'Paul Müller'],
    genres: ['Drama', 'Erotica'],
    producers: ['Eurociné'],
    composers: [],
    screenplay: [],
    pseudonyms: ['J.P. Johnson'],
    locations: [],
    trivia: [],
    imdb: 'tt0221443'
  },
  {
    title: 'Tender and Perverse Emanuelle',
    id: 60,
    year: 1973,
    cast: ['Alice Arno', 'Lina Romay', 'Jack Taylor', 'Antonio Mayans'],
    genres: ['Drama', 'Erotica', 'Thriller'],
    producers: ['Eurociné'],
    composers: ['Daniel White'],
    screenplay: [],
    pseudonyms: ['David Khune', 'J.P. Johnson'],
    locations: [],
    trivia: [],
    imdb: 'tt0070779'
  },
  {
    title: 'Kiss Me Killer',
    id: 61,
    year: 1973,
    cast: ['Alice Arno', 'Lina Romay', 'Paul Müller', 'Antonio Mayans'],
    genres: ['Thriller'],
    producers: ['Eurociné'],
    composers: ['Daniel White'],
    screenplay: [],
    pseudonyms: ['David Khune'],
    locations: [],
    trivia: [],
    imdb: 'tt0218380'
  },
  {
    title: 'Exorcism',
    id: 62,
    year: 1974,
    cast: ['Lina Romay'],
    genres: ['Horror'],
    producers: ['Eurociné'],
    composers: [],
    screenplay: [],
    pseudonyms: ['David Khune', 'J.P. Johnson'],
    locations: [],
    trivia: [],
    imdb: 'tt0083155'
  },
  {
    title: 'Célestine, an All Round Maid',
    id: 63,
    year: 1974,
    cast: ['Lina Romay', 'Howard Vernon'],
    genres: ['Comedy', 'Erotica'],
    producers: ['Comptoir français du film (Robert de Nesle)'],
    composers: [],
    screenplay: [],
    pseudonyms: ['Clifford Brown'],
    locations: [],
    trivia: [],
    imdb: 'tt0071294'
  },
  {
    title: 'Lorna... the Exorcist',
    id: 64,
    year: 1974,
    cast: ['Lina Romay', 'Howard Vernon', 'Pamela Stanford'],
    genres: ['Horror', 'Erotica'],
    producers: ['Comptoir français du film (Robert de Nesle)'],
    composers: ['Robert de Nesle'],
    screenplay: [],
    pseudonyms: ['Clifford Brown'],
    locations: [],
    trivia: ['Paco Rabane (costumes)'],
    imdb: 'tt0072019'
  },
  {
    title: 'Les Chatouilleuses',
    id: 65,
    year: 1974,
    cast: ['Lina Romay', 'Pamela Stanford'],
    genres: ['Comedy', 'Erotica', 'Western'],
    producers: ['Comptoir français du film (Robert de Nesle)'],
    composers: ['Robert de Nesle'],
    screenplay: [],
    pseudonyms: ['Clifford Brown', 'David Khune'],
    locations: [],
    trivia: [],
    imdb: 'tt0262328'
  },
  {
    title: 'Le Jouisseur',
    id: 66,
    year: 1974,
    cast: ['Lina Romay', 'Pamela Stanford'],
    genres: ['Comedy', 'Erotica'],
    producers: ['Comptoir français du film (Robert de Nesle)'],
    composers: [],
    screenplay: [],
    pseudonyms: ['Clifford Brown'],
    locations: [],
    trivia: [],
    imdb: 'tt0141446'
  },
  {
    title: 'Les Grandes Emmerdeuses',
    id: 67,
    year: 1974,
    cast: ['Lina Romay', 'Pamela Stanford'],
    genres: ['Comedy', 'Action', 'Erotica'],
    producers: ['Comptoir français du film (Robert de Nesle)'],
    composers: [],
    screenplay: [],
    pseudonyms: ['Clifford Brown', 'David Khune'],
    locations: [],
    trivia: [],
    imdb: 'tt0262395'
  },
  {
    title: 'Julietta 69',
    id: 68,
    year: 1974,
    cast: ['Lina Romay'],
    genres: ['Erotica'],
    producers: [],
    composers: [],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0079385'
  },
  {
    title: 'Midnight Party',
    id: 69,
    year: 1975,
    cast: ['Lina Romay'],
    genres: ['Drama', 'Comedy', 'Crime', 'Erotica'],
    producers: ['Eurociné', 'Erwin C. Dietrich'],
    composers: ['Daniel White', 'Alain Petit'],
    screenplay: [],
    pseudonyms: ['David Khune'],
    locations: [],
    trivia: [],
    imdb: 'tt0072793'
  },
  {
    title: 'Shining Sex',
    id: 70,
    year: 1975,
    cast: ['Lina Romay'],
    genres: ['Horror', 'Erotica'],
    producers: ['Eurociné'],
    composers: [],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0232633'
  },
  {
    title: 'Razzia sur le plaisir',
    id: 71,
    year: 1975,
    cast: ['Alice Arno', 'Pamela Stanford'],
    genres: ['Horror', 'Erotica'],
    producers: ['Eurociné'],
    composers: ['Daniel White'],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0234946'
  },
  {
    title: 'Barbed Wire Dolls',
    id: 72,
    year: 1975,
    cast: ['Lina Romay', 'Paul Müller'],
    genres: ['Horror', 'Women In Prison', 'Erotica'],
    producers: ['Erwin C. Dietrich'],
    composers: ['Daniel White'],
    screenplay: [],
    pseudonyms: ['David Khune'],
    locations: [],
    trivia: [],
    imdb: 'tt0073017'
  },
  {
    title: 'Women Behind Bars',
    id: 73,
    year: 1975,
    cast: ['Lina Romay'],
    genres: ['Horror', 'Women In Prison', 'Erotica'],
    producers: ['Eurociné'],
    composers: ['Daniel White'],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0381985'
  },
  {
    title: 'Downtown',
    id: 74,
    year: 1975,
    cast: ['Lina Romay', 'Paul Müller'],
    genres: ['Crime', 'Comedy'],
    producers: ['Erwin C. Dietrich'],
    composers: [],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0072904'
  },
  {
    title: 'Swedish Nympho Slaves',
    id: 75,
    year: 1975,
    cast: ['Lina Romay'],
    genres: ['Crime', 'Drama', 'Erotica'],
    producers: ['Erwin C. Dietrich'],
    composers: [],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0193510'
  },
  {
    title: 'Die Marquise Von Sade',
    id: 76,
    year: 1975,
    cast: ['Lina Romay'],
    genres: ['Crime', 'Drama', 'Erotica'],
    producers: ['Erwin C. Dietrich'],
    composers: [],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0074871'
  },
  {
    title: 'Mandinga',
    id: 77,
    year: 1975,
    cast: ['Lina Romay', 'William Berger'],
    genres: ['Period', 'Erotica'],
    producers: [],
    composers: [],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: ['Unfinished/Unreleased'],
    imdb: ''
  },
  {
    title: "L'Assassin portait des bas noirs",
    id: 78,
    year: 1975,
    cast: ['Lina Romay'],
    genres: ['Thriller'],
    producers: [],
    composers: [],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: ['Unfinished/Unreleased'],
    imdb: ''
  },
  {
    title: 'Girls in the Night Traffic',
    id: 79,
    year: 1976,
    cast: [],
    genres: ['Erotica', 'Porno'],
    producers: ['Erwin C. Dietrich'],
    composers: [],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0183551'
  },
  {
    title: 'Weisse Haut Auf Schwarzen Schenkeln',
    id: 80,
    year: 1976,
    cast: [],
    genres: ['Erotica', 'Porno'],
    producers: ['Erwin C. Dietrich'],
    composers: [],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0075418'
  },
  {
    title: 'In 80 Betten Um Die Welt',
    id: 81,
    year: 1976,
    cast: [],
    genres: ['Erotica', 'Porno'],
    producers: ['Erwin C. Dietrich'],
    composers: [],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0178627'
  },
  {
    title: 'Jack the Ripper',
    id: 82,
    year: 1976,
    cast: ['Klaus Kinski', 'Lina Romay'],
    genres: ['Horror', 'Thriller'],
    producers: ['Erwin C. Dietrich'],
    composers: [],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0074408'
  },
  {
    title: 'Ilsa the Wicked Women',
    id: 83,
    year: 1976,
    cast: ['Lina Romay'],
    genres: ['Horror', 'Women In Prison', 'Erotica'],
    producers: ['Erwin C. Dietrich'],
    composers: [],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0076112'
  },
  {
    title: 'Love Letters of a Portuguese Nun',
    id: 84,
    year: 1976,
    cast: ['William Berger', 'Susan Hemingway'],
    genres: ['Horror', 'Period', 'Drama'],
    producers: ['Erwin C. Dietrich'],
    composers: [],
    screenplay: [],
    pseudonyms: ['Clifford Brown'],
    locations: [],
    trivia: [],
    imdb: 'tt0076312'
  },
  {
    title: 'Blue Rita',
    id: 85,
    year: 1977,
    cast: ['Pamela Stanford'],
    genres: ['Erotica', 'Thriller', 'Drama'],
    producers: [
      'Comptoir français du film (Robert de Nesle)',
      'Erwin C. Dietrich'
    ],
    composers: [],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0167165'
  },
  {
    title: 'Satanic Sisters',
    id: 86,
    year: 1977,
    cast: ['Pamela Stanford', 'Jack Taylor'],
    genres: ['Erotica', 'Thriller'],
    producers: ['Erwin C. Dietrich'],
    composers: [],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0075322'
  },
  {
    title: 'Love Camp',
    id: 87,
    year: 1977,
    cast: [],
    genres: ['Erotica', 'Women In Prison'],
    producers: ['Erwin C. Dietrich'],
    composers: [],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0074548'
  },
  {
    title: 'Voodoo Passion',
    id: 88,
    year: 1977,
    cast: ['Jack Taylor'],
    genres: ['Adventure'],
    producers: ['Erwin C. Dietrich'],
    composers: [],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0076645'
  },
  {
    title: 'Wicked Women',
    id: 89,
    year: 1977,
    cast: ['Lina Romay'],
    genres: ['Thriller'],
    producers: ['Erwin C. Dietrich'],
    composers: [],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0220470'
  },
  {
    title: 'Women in Cellblock 9',
    id: 90,
    year: 1977,
    cast: ['Howard Vernon'],
    genres: ['Women In Prison'],
    producers: ['Erwin C. Dietrich'],
    composers: [],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0123847'
  },
  {
    title: 'Cocktail spécial',
    id: 91,
    year: 1978,
    cast: [],
    genres: ['Sadism', 'Porno'],
    producers: ['Comptoir français du film (Robert de Nesle)'],
    composers: ['Daniel White'],
    screenplay: [],
    pseudonyms: ['Clifford Brown'],
    locations: [],
    trivia: [],
    imdb: 'tt0140902'
  },
  {
    title: 'Elles font tout',
    id: 92,
    year: 1978,
    cast: ['Lina Romay', 'Susan Hemingway'],
    genres: ['Porno', 'Comedy'],
    producers: ['Comptoir français du film (Robert de Nesle)'],
    composers: ['Daniel White'],
    screenplay: [],
    pseudonyms: ['Clifford Brown'],
    locations: [],
    trivia: [],
    imdb: 'tt0218172'
  },
  {
    title: 'Je brûle de partout',
    id: 93,
    year: 1978,
    cast: ['Brigitte Lahaie', 'Susan Hemingway'],
    genres: ['Porno', 'Drama'],
    producers: ['Comptoir français du film (Robert de Nesle)'],
    composers: ['Daniel White'],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0077767'
  },
  {
    title: 'Two Female Spies With Flowered Panties',
    id: 94,
    year: 1978,
    cast: ['Lina Romay', 'Susan Hemingway'],
    genres: ['Erotica', 'Thriller', 'Eurospy'],
    producers: ['Eurociné'],
    composers: ['Daniel White', 'Jess Franco'],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0078053'
  },
  {
    title: 'The Girls of the Copacabana',
    id: 95,
    year: 1978,
    cast: ['Lina Romay', 'Juan Soler'],
    genres: ['Erotica', 'Comedy'],
    producers: ['Eurociné'],
    composers: ['Daniel White'],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0082166'
  },
  {
    title: 'The Sadist of Notre Dame',
    id: 96,
    year: 1979,
    cast: ['Lina Romay'],
    genres: ['Drama', 'Horror', 'Thriller', 'Crime'],
    producers: ['Eurociné'],
    composers: ['Daniel White'],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt3452710'
  },
  {
    title: 'Sinfonia Erotica',
    id: 97,
    year: 1979,
    cast: ['Lina Romay', 'Susan Hemingway'],
    genres: ['Drama', 'Sadism', 'Erotica'],
    producers: [],
    composers: ['Jess Franco', 'Daniel White'],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0081519'
  },
  {
    title: 'El Escarabajo de oro',
    id: 98,
    year: 1980,
    cast: ['Lina Romay', 'Antonio Mayans'],
    genres: ['Adventure', 'Comedy'],
    producers: [],
    composers: [],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: ['Unfinished/Unreleased'],
    imdb: 'tt9828802'
  },
  {
    title: 'The Cannibals',
    id: 99,
    year: 1980,
    cast: ['Lina Romay', 'Antonio Mayans', 'Pamela Stanford'],
    genres: ['Adventure', 'Horror'],
    producers: ['Eurociné'],
    composers: [],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0078936'
  },
  {
    title: 'El Sexo está loco',
    id: 100,
    year: 1980,
    cast: ['Lina Romay', 'Antonio Mayans', 'Juan Soler'],
    genres: ['Comedy', 'Erotica', 'Science Fiction'],
    producers: [],
    composers: ['Daniel White'],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0083058'
  },
  {
    title: 'Aberraciones sexuales de una mujer casada',
    id: 101,
    year: 1980,
    cast: ['Lina Romay', 'Antonio Mayans'],
    genres: ['Drama', 'Erotica'],
    producers: ['Eurociné'],
    composers: ['Daniel White', 'Jess Franco'],
    screenplay: [],
    pseudonyms: ['Clifford Brown'],
    locations: [],
    trivia: [],
    imdb: 'tt0081973'
  },
  {
    title: 'Eugenie (Historia de una perversión)',
    id: 102,
    year: 1980,
    cast: ['Lina Romay', 'Antonio Mayans', 'Katja Bienert'],
    genres: ['Drama', 'Erotica', 'Sadism'],
    producers: [],
    composers: ['Daniel White', 'Jess Franco'],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0082345'
  },
  {
    title: 'Devil Hunter',
    id: 103,
    year: 1980,
    cast: ['Antonio Mayans'],
    genres: ['Horror', 'Adventure'],
    producers: ['Eurociné'],
    composers: ['Daniel White', 'Jess Franco'],
    screenplay: [],
    pseudonyms: ['Clifford Brown'],
    locations: [],
    trivia: [],
    imdb: 'tt0080486'
  },
  {
    title: 'Sadomania',
    id: 104,
    year: 1980,
    cast: ['Antonio Mayans', 'Juan Soler'],
    genres: ['Drama', 'Thriller', 'Women In Prison'],
    producers: [],
    composers: ['Jess Franco', 'Daniel White'],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0083019'
  },
  {
    title: 'Bloody Moon',
    id: 105,
    year: 1980,
    cast: [],
    genres: ['Horror', 'Thriller'],
    producers: [],
    composers: [],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0083156'
  },
  {
    title: 'Linda',
    id: 106,
    year: 1980,
    cast: ['Antonio Mayans', 'Katja Bienert', 'Juan Soler'],
    genres: ['Adventure', 'Drama', 'Erotica'],
    producers: [],
    composers: [],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0081057'
  },
  {
    title: 'Pick-Up Girls',
    id: 107,
    year: 1981,
    cast: ['Antonio Mayans', 'Lina Romay', 'Juan Soler'],
    genres: ['Comedy', 'Crime', 'Erotica'],
    producers: [],
    composers: ['Daniel White'],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0082164'
  },
  {
    title: 'Adolescencia',
    id: 108,
    year: 1981,
    cast: [],
    genres: [],
    producers: [],
    composers: [],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: ['Unfinished/Unreleased'],
    imdb: ''
  },
  {
    title: 'Lola 2000',
    id: 109,
    year: 1981,
    cast: [
      'Lina Romay',
      'Susan Hemingway',
      'Brigitte Lahaie',
      'Pamela Stanford'
    ],
    genres: ['Porno'],
    producers: [],
    composers: [],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt1389517'
  },
  {
    title: 'El Lago de las virgenes',
    id: 110,
    year: 1981,
    cast: ['Katja Bienert'],
    genres: ['Adventure', 'Erotica'],
    producers: [],
    composers: ['Daniel White'],
    screenplay: [],
    pseudonyms: ['David Khune'],
    locations: [],
    trivia: [],
    imdb: 'tt0093381'
  },
  {
    title: 'Macumba Sexual',
    id: 111,
    year: 1981,
    cast: ['Lina Romay', 'Antonio Mayans'],
    genres: ['Horror', 'Erotica'],
    producers: ['Golden Films'],
    composers: ['Daniel White'],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0085883'
  },
  {
    title: 'Zombies Lake',
    id: 112,
    year: 1981,
    cast: ['Howard Vernon', 'Antonio Mayans'],
    genres: ['Horror', 'Zombies'],
    producers: ['Eurociné'],
    composers: ['Daniel White'],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: ['Unfinished/Unreleased'],
    imdb: 'tt0081027'
  },
  {
    title: 'Night of Open Sex',
    id: 113,
    year: 1981,
    cast: ['Lina Romay', 'Antonio Mayans'],
    genres: ['Erotica', 'Drama', 'Thriller'],
    producers: ['Golden Films'],
    composers: ['Daniel White'],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0086020'
  },
  {
    title: 'Oasis of the Zombies',
    id: 114,
    year: 1981,
    cast: ['Lina Romay', 'Antonio Mayans', 'Juan Soler'],
    genres: ['Horror', 'Zombies'],
    producers: ['Eurociné'],
    composers: ['Daniel White'],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0086486'
  },
  {
    title: 'Confesiones íntimas de una exhibicionista',
    id: 115,
    year: 1981,
    cast: ['Lina Romay', 'Antonio Mayans'],
    genres: ['Drama', 'Erotica'],
    producers: ['Golden Films'],
    composers: ['Daniel White'],
    screenplay: [],
    pseudonyms: ['David Khune', 'Candy Coaster'],
    locations: [],
    trivia: [],
    imdb: 'tt0085355'
  },
  {
    title: 'Botas negras, látigo de cuero',
    id: 116,
    year: 1982,
    cast: ['Lina Romay', 'Antonio Mayans'],
    genres: ['Drama', 'Erotica'],
    producers: ['Golden Films'],
    composers: ['Daniel White', 'Jess Franco'],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0085270'
  },
  {
    title: 'El siniestro doctor Orloff',
    id: 117,
    year: 1982,
    cast: ['Howard Vernon', 'Antonio Mayans', 'Juan Soler'],
    genres: ['Horror'],
    producers: ['Golden Films'],
    composers: ['Daniel White', 'Jess Franco'],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0088122'
  },
  {
    title: 'La Casa de las mujeres perdidas',
    id: 118,
    year: 1982,
    cast: ['Lina Romay', 'Antonio Mayans'],
    genres: ['Drama'],
    producers: ['Golden Films'],
    composers: ['Daniel White', 'Jess Franco'],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0085305'
  },
  {
    title: 'The Inconfessable Orgies of Emmanuelle',
    id: 119,
    year: 1982,
    cast: ['Antonio Mayans'],
    genres: ['Drama', 'Erotica'],
    producers: ['Golden Films'],
    composers: ['Daniel White'],
    screenplay: [],
    pseudonyms: ['Clifford Brown'],
    locations: [],
    trivia: [],
    imdb: 'tt0084449'
  },
  {
    title: 'El Hotel de los ligues',
    id: 120,
    year: 1982,
    cast: ['Lina Romay', 'Antonio Mayans', 'Juan Soler'],
    genres: ['Comedy', 'Erotica'],
    producers: ['Golden Films'],
    composers: ['Daniel White'],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0085691'
  },
  {
    title: 'Mansion of the Living Dead',
    id: 121,
    year: 1982,
    cast: ['Lina Romay', 'Antonio Mayans'],
    genres: ['Horror', 'Zombies', 'Erotica'],
    producers: ['Golden Films'],
    composers: ['Daniel White', 'Jess Franco'],
    screenplay: [],
    pseudonyms: ['David Khune'],
    locations: [],
    trivia: [],
    imdb: 'tt0089547'
  },
  {
    title: 'La Sombra del judoka contra el doctor Wong',
    id: 122,
    year: 1982,
    cast: ['Lina Romay', 'José Llamas'],
    genres: ['Action'],
    producers: ['Golden Films'],
    composers: ['Daniel White', 'Jess Franco'],
    screenplay: [],
    pseudonyms: ['Clifford Brown'],
    locations: [],
    trivia: [],
    imdb: 'tt0090046'
  },
  {
    title: 'Cries of Pleasure',
    id: 123,
    year: 1982,
    cast: ['Lina Romay', 'Antonio Mayans', 'Juan Soler'],
    genres: ['Erotica', 'Drama', 'Thriller', 'Sadism'],
    producers: ['Golden Films'],
    composers: ['Daniel White', 'Jess Franco'],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0085582'
  },
  {
    title: 'Los blues de la calle Pop (Aventuras de Felipe Malboro, volumen 8)',
    id: 124,
    year: 1982,
    cast: ['Lina Romay', 'Antonio Mayans', 'José Llamas'],
    genres: ['Crime', 'Comedy'],
    producers: [],
    composers: ['Jess Franco'],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0085257'
  },
  {
    title: 'Furia en el trópico',
    id: 125,
    year: 1982,
    cast: ['Lina Romay', 'Antonio Mayans'],
    genres: ['Thriller', 'Women In Prison'],
    producers: [],
    composers: ['Jess Franco', 'Daniel White'],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0083981'
  },
  {
    title: 'Revenge in the House of Usher',
    id: 126,
    year: 1982,
    cast: ['Lina Romay', 'Howard Vernon', 'Antonio Mayans', 'José Llamas'],
    genres: ['Horror'],
    producers: ['Eurociné'],
    composers: ['Daniel White'],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0084592'
  },
  {
    title: 'Diamonds of Kilimandjaro',
    id: 127,
    year: 1982,
    cast: ['Lina Romay', 'Katja Bienert', 'Antonio Mayans'],
    genres: ['Adventure'],
    producers: ['Eurociné'],
    composers: ['Daniel White', 'Jess Franco'],
    screenplay: [],
    pseudonyms: ['J.P. Johnson'],
    locations: [],
    trivia: [],
    imdb: 'tt0086428'
  },
  {
    title: 'Lilian (la virgen pervertida)',
    id: 128,
    year: 1982,
    cast: ['Lina Romay', 'Katja Bienert', 'Antonio Mayans', 'José Llamas'],
    genres: ['Adventure'],
    producers: ['Golden Films'],
    composers: ['Daniel White', 'Jess Franco'],
    screenplay: [],
    pseudonyms: ['Clifford Brown'],
    locations: [],
    trivia: [],
    imdb: 'tt0087624'
  },
  {
    title: 'Night Has a Thousand Desires',
    id: 129,
    year: 1983,
    cast: ['Lina Romay', 'José Llamas'],
    genres: ['Thriller', 'Erotica'],
    producers: ['Golden Films'],
    composers: ['Daniel White', 'Jess Franco'],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0087723'
  },
  {
    title: 'Un Pito para tres',
    id: 130,
    year: 1983,
    cast: ['Lina Romay', 'Antonio Mayans'],
    genres: ['Porno'],
    producers: [],
    composers: [],
    screenplay: [],
    pseudonyms: ['Candy Coaster'],
    locations: [],
    trivia: [],
    imdb: 'tt0087920'
  },
  {
    title: 'The Sexual Story of O',
    id: 131,
    year: 1983,
    cast: [],
    genres: ['Drama', 'Erotica'],
    producers: ['Golden Films'],
    composers: ['Daniel White', 'Jess Franco'],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0087413'
  },
  {
    title: 'Barrio Chino',
    id: 132,
    year: 1983,
    cast: ['Lina Romay', 'Antonio Mayans', 'José Llamas'],
    genres: ['Drama', 'Erotica'],
    producers: ['Golden Films'],
    composers: ['Daniel White'],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: ['Unfinished/Unreleased'],
    imdb: ''
  },
  {
    title: 'En busca del dragón dorado',
    id: 133,
    year: 1983,
    cast: [],
    genres: ['Adventure', 'Family'],
    producers: ['Golden Films'],
    composers: ['Daniel White', 'Jess Franco'],
    screenplay: [],
    pseudonyms: ['J.P. Johnson'],
    locations: [],
    trivia: [],
    imdb: 'tt0085487'
  },
  {
    title: 'Golden Temple Amazons',
    id: 134,
    year: 1983,
    cast: ['Antonio Mayans', 'William Berger', 'Lina Romay'],
    genres: ['Adventure'],
    producers: ['Golden Films', 'Eurociné'],
    composers: ['Daniel White', 'Jess Franco'],
    screenplay: [],
    pseudonyms: ['Clifford Brown'],
    locations: [],
    trivia: [],
    imdb: 'tt0165621'
  },
  {
    title: 'El Abuelo, la condesa y Escarlata la traviesa',
    id: 135,
    year: 1983,
    cast: ['Lina Romay', 'Antonio Mayans', 'José Llamas', 'Juan Soler'],
    genres: ['Adventure', 'Erotica'],
    producers: ['Golden Films'],
    composers: ['Daniel White'],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: ['Unfinished/Unreleased'],
    imdb: 'tt0103614'
  },
  {
    title: 'Camino Solitario',
    id: 136,
    year: 1983,
    cast: ['Antonio Mayans', 'José Llamas', 'Lina Romay'],
    genres: ['Crime', 'Thriller'],
    producers: [],
    composers: ['Daniel White', 'Jess Franco'],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0087029'
  },
  {
    title: 'Las Chicas del tanga',
    id: 137,
    year: 1983,
    cast: ['Antonio Mayans', 'José Llamas', 'Lina Romay', 'Juan Soler'],
    genres: ['Comedy', 'Thriller'],
    producers: [],
    composers: [],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0092748'
  },
  {
    title: 'Sola ante el terror',
    id: 138,
    year: 1983,
    cast: ['Antonio Mayans', 'Lina Romay'],
    genres: ['Horror'],
    producers: [],
    composers: ['Daniel White'],
    screenplay: [],
    pseudonyms: ['Clifford Brown'],
    locations: [],
    trivia: [],
    imdb: 'tt0086334'
  },
  {
    title: 'Sangre en mis zapatos',
    id: 139,
    year: 1983,
    cast: [
      'Antonio Mayans',
      'Lina Romay',
      'Howard Vernon',
      'Juan Soler',
      'José Llamas'
    ],
    genres: ['Crime', 'Comedy'],
    producers: [],
    composers: ['Daniel White', 'Jess Franco'],
    screenplay: [],
    pseudonyms: ['Clifford Brown'],
    locations: [],
    trivia: [],
    imdb: 'tt0086239'
  },
  {
    title: 'Una Rajita para dos',
    id: 140,
    year: 1983,
    cast: ['Antonio Mayans', 'Lina Romay', 'José Llamas'],
    genres: ['Porno'],
    producers: [],
    composers: ['Daniel White'],
    screenplay: [],
    pseudonyms: ['Lulu Laverne'],
    locations: [],
    trivia: [],
    imdb: 'tt0087976'
  },
  {
    title: 'Claire',
    id: 141,
    year: 1983,
    cast: [
      'Pamela Stanford',
      'Lina Romay',
      'Brigitte Lahaie',
      'Susan Hemingway'
    ],
    genres: ['Porno'],
    producers: [],
    composers: ['Robert de Nesle'],
    screenplay: [],
    pseudonyms: ['Clifford Brown'],
    locations: [],
    trivia: [],
    imdb: 'tt2342037'
  },
  {
    title: '¿Cuánto cobra un espía?',
    id: 142,
    year: 1984,
    cast: ['Juan Soler', 'Lina Romay', 'Antonio Mayans'],
    genres: ['Action', 'Comedy'],
    producers: [],
    composers: [],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0088460'
  },
  {
    title: 'Juego sucio en Casablanca',
    id: 143,
    year: 1984,
    cast: [
      'Juan Soler',
      'Lina Romay',
      'Antonio Mayans',
      'José Llamas',
      'William Berger',
      'Luis Barboo'
    ],
    genres: ['Action', 'Thriller'],
    producers: [],
    composers: [],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0089388'
  },
  {
    title: 'El asesino llevaba medias negras',
    id: 144,
    year: 1984,
    cast: ['Lina Romay', 'Antonio Mayans', 'William Berger'],
    genres: [],
    producers: [],
    composers: ['Jess Franco'],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: ['Unfinished/Unreleased'],
    imdb: 'tt0262241'
  },
  {
    title: 'La Chica des los labios rojos',
    id: 145,
    year: 1984,
    cast: ['Lina Romay', 'Antonio Mayans', 'José Llamas'],
    genres: ['Comedy', 'Action'],
    producers: [],
    composers: [],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0090824'
  },
  {
    title: 'Bahía blanca',
    id: 146,
    year: 1984,
    cast: ['Lina Romay', 'Antonio Mayans', 'José Llamas', 'Juan Soler'],
    genres: ['Drama', 'Thriller'],
    producers: [],
    composers: [],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0086931'
  },
  {
    title: 'Voces de muerte',
    id: 147,
    year: 1984,
    cast: ['Lina Romay', 'Antonio Mayans', 'José Llamas'],
    genres: ['Thriller'],
    producers: ['Golden Films'],
    composers: ['Daniel White'],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: ['Unfinished/Unreleased'],
    imdb: 'tt0086555'
  },
  {
    title: 'Las últimas de Filipinas',
    id: 148,
    year: 1984,
    cast: ['Lina Romay', 'José Llamas'],
    genres: ['Adventure'],
    producers: [],
    composers: [],
    screenplay: [],
    pseudonyms: ['David Khune'],
    locations: [],
    trivia: [],
    imdb: 'tt0092311'
  },
  {
    title: 'Viaje a Bangkok, ataúd incluido',
    id: 149,
    year: 1984,
    cast: ['Howard Vernon', 'José Llamas', 'Juan Soler', 'Antonio Mayans'],
    genres: ['Adventure', 'Action'],
    producers: [],
    composers: [],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0090258'
  },
  {
    title: 'Bangkok, cita con la muerte',
    id: 150,
    year: 1984,
    cast: ['Lina Romay', 'José Llamas', 'Antonio Mayans'],
    genres: ['Adventure', 'Action'],
    producers: ['Golden Films'],
    composers: ['Daniel White'],
    screenplay: [],
    pseudonyms: ['Clifford Brown'],
    locations: [],
    trivia: [],
    imdb: 'tt0088769'
  },
  {
    title: 'Gentes del rio',
    id: 151,
    year: 1984,
    cast: [
      'Howard Vernon',
      'Lina Romay',
      'Juan Soler',
      'José Llamas',
      'Antonio Mayans'
    ],
    genres: [],
    producers: [],
    composers: [],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: ['Unfinished/Unreleased'],
    imdb: 'tt0322581'
  },
  {
    title: 'Una de chinos',
    id: 152,
    year: 1985,
    cast: ['Lina Romay', 'José Llamas', 'Juan Soler'],
    genres: [],
    producers: ['Golden Films'],
    composers: ['Daniel White'],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: ['Unfinished/Unreleased'],
    imdb: 'tt0818947'
  },
  {
    title: 'La Esclava blanca',
    id: 153,
    year: 1985,
    cast: ['Lina Romay', 'José Llamas'],
    genres: ['Adventure'],
    producers: [],
    composers: ['Daniel White', 'Jess Franco'],
    screenplay: [],
    pseudonyms: ['Clifford Brown'],
    locations: [],
    trivia: [],
    imdb: 'tt0089105'
  },
  {
    title: 'La Venganza del rinoceronte blanco',
    id: 154,
    year: 1985,
    cast: ['Lina Romay', 'José Llamas', 'Antonio Mayans'],
    genres: ['Comedy'],
    producers: ['Golden Films'],
    composers: ['Daniel White'],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: ['Unfinished/Unreleased'],
    imdb: ''
  },
  {
    title: 'El Ojete de Lulú',
    id: 155,
    year: 1985,
    cast: ['Lina Romay', 'José Llamas'],
    genres: ['Comedy', 'Porno'],
    producers: [],
    composers: ['Daniel White'],
    screenplay: [],
    pseudonyms: ['Candy Coaster'],
    locations: [],
    trivia: [],
    imdb: 'tt0186417'
  },
  {
    title: 'El Chupete de Lulú',
    id: 156,
    year: 1985,
    cast: ['Lina Romay', 'José Llamas'],
    genres: ['Comedy', 'Porno'],
    producers: [],
    composers: ['Daniel White'],
    screenplay: [],
    pseudonyms: ['Lulu Laverne'],
    locations: [],
    trivia: [],
    imdb: 'tt0090843'
  },
  {
    title: 'Entre pitos anda el juego',
    id: 157,
    year: 1985,
    cast: ['Lina Romay', 'José Llamas'],
    genres: ['Comedy', 'Porno'],
    producers: [],
    composers: ['Daniel White'],
    screenplay: [],
    pseudonyms: ['Lulu Laverne'],
    locations: [],
    trivia: [],
    imdb: 'tt0091010'
  },
  {
    title: 'El Mirón y la exhibicionista',
    id: 158,
    year: 1985,
    cast: ['Lina Romay', 'José Llamas'],
    genres: ['Drama', 'Porno'],
    producers: [],
    composers: ['Daniel White'],
    screenplay: [],
    pseudonyms: ['Lulu Laverne'],
    locations: [],
    trivia: [],
    imdb: 'tt0091526'
  },
  {
    title: 'Las Chuponas',
    id: 159,
    year: 1985,
    cast: ['Lina Romay', 'José Llamas', 'Antonio Mayans'],
    genres: ['Porno'],
    producers: [],
    composers: ['Daniel White'],
    screenplay: [],
    pseudonyms: ['Candy Coaster'],
    locations: [],
    trivia: [],
    imdb: 'tt0090844'
  },
  {
    title: 'Para las nenas... leche calentita',
    id: 160,
    year: 1986,
    cast: ['Lina Romay', 'José Llamas', 'Antonio Mayans'],
    genres: ['Porno', 'Comedy'],
    producers: [],
    composers: ['Daniel White'],
    screenplay: [],
    pseudonyms: ['Candy Coaster'],
    locations: [],
    trivia: [],
    imdb: 'tt0091718'
  },
  {
    title: 'Esclavas del crimen',
    id: 161,
    year: 1986,
    cast: ['Lina Romay', 'José Llamas'],
    genres: ['Pulp', 'Thriller'],
    producers: [],
    composers: ['Daniel White'],
    screenplay: [],
    pseudonyms: ['David Khune', 'J.P. Johnson'],
    locations: [],
    trivia: [],
    imdb: 'tt0092979'
  },
  {
    title: 'Teleporno',
    id: 162,
    year: 1986,
    cast: ['Lina Romay'],
    genres: ['Porno', 'Comedy'],
    producers: ['Golden Films'],
    composers: [],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: ['Unfinished/Unreleased'],
    imdb: ''
  },
  {
    title: 'Bragueta historia',
    id: 163,
    year: 1986,
    cast: ['Lina Romay', 'José Llamas'],
    genres: ['Porno'],
    producers: ['Golden Films'],
    composers: [],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: ['Unfinished/Unreleased'],
    imdb: 'tt0266363'
  },
  {
    title: 'Las Tribulaciones de un Buda Bizco',
    id: 164,
    year: 1986,
    cast: ['Lina Romay', 'Antonio Mayans', 'Howard Vernon'],
    genres: ['Family'],
    producers: ['Golden Films'],
    composers: [],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: ['Unfinished/Unreleased'],
    imdb: 'tt0324321'
  },
  {
    title: 'S.I.D.A. la peste del siglo veinte',
    id: 165,
    year: 1986,
    cast: ['Lina Romay', 'Antonio Mayans', 'Juan Soler'],
    genres: [],
    producers: ['Golden Films', 'Eurociné'],
    composers: [],
    screenplay: [],
    pseudonyms: ['David Khune'],
    locations: [],
    trivia: ['Unfinished/Unreleased'],
    imdb: 'tt0435392'
  },
  {
    title: 'Phollastia',
    id: 166,
    year: 1987,
    cast: ['Lina Romay'],
    genres: ['Porno'],
    producers: [],
    composers: ['Daniel White'],
    screenplay: [],
    pseudonyms: ['Lulu Laverne'],
    locations: [],
    trivia: [],
    imdb: 'tt0093732'
  },
  {
    title: 'Phalo Crest',
    id: 167,
    year: 1987,
    cast: ['Lina Romay'],
    genres: ['Porno', 'Comedy'],
    producers: [],
    composers: ['Daniel White'],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0093003'
  },
  {
    title: 'Dark Mission',
    id: 168,
    year: 1987,
    cast: ['Christopher Lee', 'Antonio Mayans', 'Brigitte Lahaie'],
    genres: ['Adventure', 'Action'],
    producers: ['Eurociné'],
    composers: [],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0094950'
  },
  {
    title: 'Faceless',
    id: 169,
    year: 1987,
    cast: ['Helmut Berger', 'Lina Romay', 'Howard Vernon', 'Brigitte Lahaie'],
    genres: ['Horror', 'Mad Scientists'],
    producers: ['René Chateau Productions'],
    composers: [],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0095125'
  },
  {
    title: 'Esmeralda Bay',
    id: 170,
    year: 1988,
    cast: ['Fernando Rey', 'Lina Romay', 'Antonio Mayans'],
    genres: ['Action', 'War'],
    producers: ['Eurociné'],
    composers: [],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0096877'
  },
  {
    title: 'Fall of the Eagles',
    id: 171,
    year: 1989,
    cast: ['Christopher Lee', 'Antonio Mayans'],
    genres: ['Drama', 'War'],
    producers: ['Eurociné'],
    composers: ['Daniel White'],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0212872'
  },
  {
    title: 'Downtown Heat',
    id: 172,
    year: 1990,
    cast: ['Lina Romay', 'Antonio Mayans'],
    genres: ['Action', 'Thriller'],
    producers: [],
    composers: ['Daniel White'],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0109441'
  },
  {
    title: 'Jungle of Fear',
    id: 173,
    year: 1993,
    cast: ['Lina Romay', 'Antonio Mayans', 'William Berger'],
    genres: ['Action', 'Adventure'],
    producers: [],
    composers: [],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: ['Unfinished/Unreleaed'],
    imdb: 'tt1772929'
  },
  {
    title: 'Killer Barbys',
    id: 174,
    year: 1996,
    cast: [],
    genres: ['Horror'],
    producers: [],
    composers: ['Daniel White', 'Jess Franco'],
    screenplay: [],
    pseudonyms: ['David Khune'],
    locations: [],
    trivia: [],
    imdb: 'tt0116769'
  },
  {
    title: 'Tender Flesh',
    id: 175,
    year: 1997,
    cast: ['Lina Romay'],
    genres: ['Horror'],
    producers: ['One Shot Productions'],
    composers: ['Daniel White', 'Jess Franco'],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0157102'
  },
  {
    title: 'Mari-Cookie and the Killer Tarantula in 8 Legs to Love You',
    id: 176,
    year: 1998,
    cast: ['Lina Romay', 'Linnea Quigley'],
    genres: ['Horror'],
    producers: ['One Shot Productions'],
    composers: ['Daniel White', 'Jess Franco'],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0238406'
  },
  {
    title: 'Lust for Frankenstein',
    id: 177,
    year: 1998,
    cast: ['Lina Romay'],
    genres: ['Horror', 'Mad Scientists'],
    producers: ['One Shot Productions'],
    composers: ['Jess Franco'],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0175621'
  },
  {
    title: "Dr. Wong's Virtual Hell",
    id: 178,
    year: 1998,
    cast: ['Lina Romay', 'Howard Vernon'],
    genres: ['Horror', 'Pulp', 'Adventure'],
    producers: ['One Shot Productions'],
    composers: ['Jess Franco'],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0228237'
  },
  {
    title: 'Vampire Blues',
    id: 179,
    year: 1998,
    cast: ['Lina Romay'],
    genres: ['Horror', 'Vampires'],
    producers: ['One Shot Productions'],
    composers: ['Jess Franco', 'Daniel White'],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0209458'
  },
  {
    title: 'Red Silk',
    id: 180,
    year: 1999,
    cast: ['Lina Romay'],
    genres: ['Crime', 'Comedy'],
    producers: ['One Shot Productions'],
    composers: ['Jess Franco'],
    screenplay: [],
    pseudonyms: ['Clifford Brown', 'David Khune'],
    locations: [],
    trivia: [],
    imdb: 'tt0274041'
  },
  {
    title: 'Broken Dolls',
    id: 181,
    year: 1999,
    cast: ['Lina Romay'],
    genres: ['Drama'],
    producers: ['One Shot Productions'],
    composers: ['Jess Franco', 'Daniel White'],
    screenplay: [],
    pseudonyms: ['David Khune'],
    locations: [],
    trivia: [],
    imdb: 'tt0273133'
  },
  {
    title: 'Blind Target',
    id: 182,
    year: 2000,
    cast: ['Lina Romay', 'Linnea Quigley'],
    genres: ['Thriller'],
    producers: ['One Shot Productions'],
    composers: ['Jess Franco', 'Daniel White'],
    screenplay: [],
    pseudonyms: ['David Khune'],
    locations: [],
    trivia: [],
    imdb: 'tt0260758'
  },
  {
    title: 'Helter Skelter',
    id: 183,
    year: 2000,
    cast: ['Lina Romay'],
    genres: ['Horror'],
    producers: ['One Shot Productions'],
    composers: ['Jess Franco', 'Daniel White', 'Alain Petit'],
    screenplay: [],
    pseudonyms: ['Clifford Brown', 'David Khune'],
    locations: [],
    trivia: [],
    imdb: 'tt0273259'
  },
  {
    title: 'Vampire Junction',
    id: 184,
    year: 2001,
    cast: ['Lina Romay'],
    genres: ['Horror', 'Western', 'Vampires'],
    producers: ['One Shot Productions'],
    composers: ['Jess Franco', 'Daniel White'],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0274189'
  },
  {
    title: 'Incubus',
    id: 185,
    year: 2002,
    cast: ['Lina Romay'],
    genres: ['Horror'],
    producers: ['One Shot Productions'],
    composers: ['Daniel White'],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0289719'
  },
  {
    title: 'Killer Barbys vs Dracula',
    id: 186,
    year: 2002,
    cast: ['Lina Romay', 'Katja Bienert'],
    genres: ['Horror', 'Comedy', 'Musical'],
    producers: ['One Shot Productions'],
    composers: [],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0327001'
  },
  {
    title: 'Las Flores de la pasión',
    id: 187,
    year: 2002,
    cast: ['Lina Romay'],
    genres: ['Erotica'],
    producers: [],
    composers: ['Jess Franco', 'Daniel White'],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0458686'
  },
  {
    title: 'Flores de la perversión',
    id: 188,
    year: 2002,
    cast: ['Lina Romay'],
    genres: ['Erotica'],
    producers: [],
    composers: ['Jess Franco'],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0458687'
  },
  {
    title: 'Snakewoman',
    id: 189,
    year: 2005,
    cast: ['Lina Romay', 'Antonio Mayans'],
    genres: ['Erotica', 'Horror', 'Vampires'],
    producers: ['One Shot Productions'],
    composers: ['Jess Franco'],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt0478267'
  },
  {
    title: 'La Cripta de las mujeres malditas',
    id: 190,
    year: 2007,
    cast: [],
    genres: ['Erotica', 'Horror'],
    producers: [],
    composers: ['Daniel White'],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt1269374'
  },
  {
    title: 'Paula-Paula',
    id: 191,
    year: 2009,
    cast: ['Lina Romay'],
    genres: ['Erotica'],
    producers: [],
    composers: [],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt1588882'
  },
  {
    title: 'Al Pereira vs. the Alligator Ladies',
    id: 192,
    year: 2012,
    cast: ['Antonio Mayans'],
    genres: ['Erotica', 'Comedy', 'Crime'],
    producers: [],
    composers: ['Jess Franco'],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt2306814'
  },
  {
    title: 'Revenge of the Alligator Ladies',
    id: 193,
    year: 2013,
    cast: ['Antonio Mayans'],
    genres: ['Erotica', 'Comedy', 'Documentary'],
    producers: [],
    composers: ['Daniel White'],
    screenplay: [],
    pseudonyms: [],
    locations: [],
    trivia: [],
    imdb: 'tt3185692'
  }
];

export default films;
